// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

document.addEventListener('turbo:frame-missing', (event) => {
  const { detail: { response } } = event;

  event.preventDefault();
  if (response.redirected) {
    location.href = response.url;
  } else {
    location.reload();
  }
});

console.log('Registering service worker...');
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      await navigator.serviceWorker.register('/service-worker.js', {
        scope: './',
      });
      console.log('Service worker now registered!');
    } catch (error) {
      console.log('Error registering service worker: ', error);
    }
  });
} else {
  console.log('Service worker not supported');
}
